import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import api from '../api/axiosConfig';

Modal.setAppElement('#root');

const Wrap = styled.div`
  padding: 18px;
`;

const Title = styled.h2`
  margin: 0 0 12px;
  color: #053969;
`;

const Row = styled.div`
  display: grid;
  gap: 10px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  outline: none;

  &:focus {
    border-color: rgba(5, 57, 105, 0.6);
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  outline: none;
  resize: vertical;

  &:focus {
    border-color: rgba(5, 57, 105, 0.6);
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 12px;
`;

const Btn = styled.button`
  border: none;
  cursor: pointer;
  font-weight: 700;
  padding: 12px 16px;
  border-radius: 999px;
  opacity: ${(p) => (p.disabled ? 0.7 : 1)};
`;

const BtnClose = styled(Btn)`
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.2);
`;

const BtnSend = styled(Btn)`
  background: #053969;
  color: #fff;
`;

export default function OrderModal({ open, onClose }) {
  const { t } = useTranslation();
  const [isSending, setIsSending] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    budget: '',
    details: '',
  });

  useEffect(() => {
    if (!open) return;
    const onEsc = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let nextValue = value;


    if (name === 'phone') {
      // разрешаем только цифры, пробел, +, -, (, )
      nextValue = value.replace(/[^0-9+\-()\s]/g, '');
    }

    setForm((prev) => ({
      ...prev,
      [name]: nextValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSending) return;

   
    const phoneHasLetters = /[A-Za-zА-Яа-яЁё]/.test(form.phone);

   

    if (phoneHasLetters) {
      alert('Phone must not contain letters');
      return;
    }

    try {
      setIsSending(true);

      const res = await api.post('/orderform/', form);

      console.log('ORDER SUCCESS:', res.data);
      alert('Thanks! Your request has been sent.');

      setForm({
        name: '',
        email: '',
        phone: '',
        budget: '',
        details: '',
      });

      onClose?.();
    } catch (error) {
      console.error('ORDER ERROR:', error?.response?.data || error?.message);
      alert('Error sending order');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      contentLabel={t('order.formLabel')}
      style={{
        overlay: { backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 3000 },
        content: {
          maxWidth: '560px',
          width: 'calc(100% - 24px)',
          margin: 'auto',
          borderRadius: '22px',
          padding: '0',
          border: 'none',
          inset: '50% auto auto 50%',
          transform: 'translate(-50%, -50%)',
        },
      }}
    >
      <Wrap>
        <Title>{t('order.modalTitle')}</Title>

        <form onSubmit={handleSubmit}>
          <Row>
            <Input
              name="name"
              placeholder={t('order.namePlaceholder')}
              required
              value={form.name}
              onChange={handleChange}
            />

            <Input
              name="email"
              type="email"
              placeholder={t('order.emailPlaceholder')}
              required
              value={form.email}
              onChange={handleChange}
            />

            <Input
              name="phone"
              placeholder={t('order.phonePlaceholder')}
              value={form.phone}
              onChange={handleChange}
            />

            <Input
              name="budget"
              placeholder={t('order.budgetPlaceholder')}
              value={form.budget}
              onChange={handleChange}
            />

            <Textarea
              name="details"
              placeholder={t('order.detailsPlaceholder')}
              required
              value={form.details}
              onChange={handleChange}
            />
          </Row>

          <Buttons>
            <BtnClose type="button" onClick={onClose} disabled={isSending}>
              {t('common.close')}
            </BtnClose>
            <BtnSend type="submit" disabled={isSending}>
              {isSending ? 'Sending…' : t('common.send')}
            </BtnSend>
          </Buttons>
        </form>
      </Wrap>
    </Modal>
  );
}
